import { useEffect } from 'react'
import { DefaultValues, FieldValues, useFormContext } from 'react-hook-form'

/**
 * Re-seeds the surrounding form when its `defaults` change (e.g. the merchant is
 * refetched in the background), while keeping any fields the user has edited via
 * `keepDirtyValues`. Pass a memoized `defaults` so the reset only runs when the
 * source data actually changes. Must be used inside a FormProvider.
 */
export function useSyncFormDefaults<T extends FieldValues>(defaults: DefaultValues<T>): void {
  const { reset } = useFormContext<T>()

  useEffect(() => {
    reset(defaults, { keepDirtyValues: true })
  }, [defaults, reset])
}
